<template>
    <el-card>
        <div class="course-content material-index is-always-shadow">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane
                    :label="$t('Message.newsList')"
                    v-if="$$filterPermission('消息-消息列表-消息列表的查看')"
                    name="second"
                    :lazy="true"
                    v-once>
                    <message-list />
                </el-tab-pane >

                <el-tab-pane :label="$t('tooltip.system')" name="first" :lazy="true" v-once>
                    <notice-list />
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-card>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import NoticeList from '@/components/TableCom/Setting/NoticeList';
import MessageList from '@/components/TableCom/Setting/MessageList';

export default {
    components: {
        NoticeList,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        MessageList,
    },
    data() {
        return {
            editableTabs: [
                {
                    name: 'second',
                    isShow: this.$$filterPermission('消息-消息列表-消息列表的查看'),
                }, {
                    name: 'first',
                    isShow: true,
                },
            ],
        };
    },
    mixins: [require('../../mixins/CacheQuery').default],
    mounted() {
    },
    computed: {
    },
    methods: {
        handleClick(tab, event) {},
    },
};

</script>
